import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/header';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HomePage from './pages/Home';
import MarketPlacePage from './pages/Marketplace';
import InventoryPage from './pages/Inventory';
import RefferalProgramPage from './pages/Refferal';
import ErrorPage from './pages/Error';
import Footer from './components/footer';
import NFTMint from './components/nft-mint';
import InventoryNFTDetail from './components/inventory-nft-detail';
import MarketplaceNFTDetail from './components/marketplace-nft-detail';
import ConnectWalletBox from './components/connect-wallet-box';
import SellBox from './components/sell-box';
import TransferBox from './components/transfer-box';
import ComingSoon from './pages/Coming-soon';
function App() {
  return (
    <>
    {/* <head>
    <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" /> 
<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
    </head> */}
      <div className='w-full min-h-screen relative  '>
        <SellBox/>
        <TransferBox/>
        <ConnectWalletBox/>
        <Router>
          <div className='App min-h-screen flex flex-col justify-between bg-secondary'>
            <div className='w-full'>
            <Header />
            <div className=''>
              <Routes>
                {/* <Route path="coming" element={<ComingSoon />} /> */}
                <Route path="/" element={<HomePage />} />
                <Route path="marketplace" element={<MarketPlacePage />} />
                <Route path="inventory/mint/:boxId" element={<NFTMint />} />
                <Route path="marketplace/:nftId" element={<MarketplaceNFTDetail />} />
                <Route path="inventory" element={<InventoryPage />} />
                <Route path="inventory/:nftId" element={<InventoryNFTDetail />} />
                <Route path="refferal" element={<RefferalProgramPage />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
            </div>
            </div>
            <Footer />
          </div>
        </Router>
      </div>
    </>
  );
}

export default App;
